import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Debounce } from "@/decorators";
import service from "@/api/request";
const UE = window.UE;
const UEDITOR_CONFIG = window.UEDITOR_CONFIG;
const hasSupportObserver = 'ResizeObserver' in window && typeof window['ResizeObserver'] === 'function';
let UEditor = class UEditor extends Vue {
    constructor() {
        super(...arguments);
        this.ue = null;
        this.previewStatus = false;
        this.previewCon = false;
        this.ueHtml = '';
        this.catchRemoteState = false;
        this.example = false;
        this.hasReady = false;
        this.resizeObserver = null;
        // // 点击按钮触发上传图片
        // triggerImgUpload() {
        //   this.triggerUpload("picture", this.ueditorAddImage)
        // }
        // // 富文本插入图片
        // ueditorAddImage(images: any[]) {
        //   this.uploadSucesss('image');
        //   let imgDom = this.createImgDom(images);
        //   this.insertDom(imgDom);
        // }
        // // 创建imgdom
        // createImgDom(images: any[]) {
        //   return images.reduce((acc, cur) => `${acc}<img src="${cur.url}" alt="" width="100%" height="auto" title="${cur.name}" alt="${cur.name}"/>`, '')
        // }
        // // 点击按钮触发上传音频
        // triggerAudioUpload() {
        //   this.triggerUpload('audio', this.ueditorAddAudio); // let src = 'https://iframe.xiaoeknow.com/page/?id=B099D9B6-544D-AEE8-BD3A-1EF09EDCE44E&type=2'
        //   // let audio_data = [
        //   //     {
        //   //         app_id: window.__app_id,
        //   //         file_id: '7ab1bde7fdf1d56a9ecea1dabcb9802a1577930637',
        //   //         audio_title: '测试',
        //   //         file_url: 'http://wechatapppro-1252524126.file.myqcloud.com/b_user/audio/YXVkaW9fY3JlYXRlQXVkaW9fM2FmMmJjYzI.mp3',
        //   //         audio_size: 352256,
        //   //         audio_length: 23
        //   //     }
        //   // ]
        //   // setTimeout(this.ueditorAddAudio(audio_data), 1000)
        // }
        // // 音频上传成功回调
        // ueditorAddAudio(audio_data) {
        //   UE.insertAudioApi(audio_data, this.createAudioDom, this.audioUploadFail);
        // }
        // // 音频上传失败
        // audioUploadFail(msg) {
        //   this.uploadFail('audio', msg);
        // }
        // // 创建audio
        // createAudioDom(html) {
        //   this.uploadSucesss('audio');
        //   this.insertDom(html);
        // }
        // // 触发视频上传
        // triggerVideoUpload() {
        //   this.triggerUpload('video', this.ueditorAddVideo); // let video_data = [
        //   //     {
        //   //         app_id: window.__app_id,
        //   //         file_id: '7ab1bde7fdf1d56a9ecea1dabcb9802a1577930637',
        //   //         video_title: '测试',
        //   //         file_url: 'http://wechatapppro-1252524126.file.myqcloud.com/b_user/audio/YXVkaW9fY3JlYXRlQXVkaW9fM2FmMmJjYzI.mp3',
        //   //         video_size: 352256,
        //   //         video_length: 23
        //   //     }
        //   // ]
        //   // setTimeout(this.ueditorAddVideo(video_data), 1000)
        // }
        // // 视频上传成功回调
        // ueditorAddVideo(video_data) {
        //   UE.insertVideoApi(video_data, this.createVideoDom, this.videoUploadFail);
        // }
        // // 视频上传失败
        // videoUploadFail(msg) {
        //   this.uploadFail('video', msg);
        // }
        // // 创建vedio
        // createVideoDom(html) {
        //   this.uploadSucesss('video');
        //   this.insertDom(html);
        // }
        // // 触发上传
        // triggerUpload(type: string, callback: Function) {
        //   this.openMaterialDialog(type, callback)
        // }
        // 插入dom
        // insertDom(html: string) {
        //   this.ue.execCommand("inserthtml", html)
        // }
        // uploadSucesss(e) { }
        // uploadFail(e, t) { }
        // openMaterialDialog(type: string, cb: Function) {
        //   const params = {
        //     type: type,
        //     multiple: type === "picture"
        //   };
        //   if (type == 'video') {
        //     Object.assign(params, {
        //       limitTypes: ["mp4", "m3u8"]
        //     })
        //   }
        //   // this.$material(params).then((res) => {
        //   //   console.log(res);
        //   //   if (!res) return;
        //   //   if (cb && typeof cb === 'function') {
        //   //     let opt = this.transformMateriaData(type, res.data);
        //   //     console.log('opt', opt);
        //   //     opt && cb(opt);
        //   //   }
        //   // }).catch(action => {
        //   //   console.log(action)
        //   // })
        // }
        // transformMateriaData(type: string, data: any[]) {
        //   if ("picture" === type) {
        //     return data.map(item => ({
        //       url: item.url,
        //       name: item.title
        //     }))
        //   }
        //   // else if (type === 'audio') {
        //   //   data = data[0];
        //   //   let opt = [{
        //   //     app_id: window.__app_id,
        //   //     file_id: data.material_property.file_id,
        //   //     audio_title: data.title,
        //   //     file_url: data.url,
        //   //     audio_size: data.material_size,
        //   //     audio_length: data.material_property.length || 0
        //   //   }];
        //   //   return opt;
        //   // } else if (type === 'video') {
        //   //   data = data[0];
        //   //   let opt = [{
        //   //     app_id: window.__app_id,
        //   //     file_id: data.material_property.file_id,
        //   //     video_title: data.title,
        //   //     file_url: data.url,
        //   //     video_size: data.material_size,
        //   //     video_length: data.material_property.length || 0
        //   //   }];
        //   //   return opt;
        //   // }
        // }
    }
    get ueEditorId() {
        return `ueditor_${this.ueId}`;
    }
    get previewBtnWidth() {
        return UEDITOR_CONFIG.initialFrameWidth + 24 || 624;
    }
    created() {
        console.log("--ueEditorId--", this.ueEditorId);
        // this.handleImageSizeChange = debounce(() => {
        //   this.ue && this.ue.fireEvent("contentChange")
        // })
    }
    mounted() {
        this.$nextTick(() => {
            const config = Object.assign(UEDITOR_CONFIG, this.ueConfig);
            config.initialContent = this.ueInitContent;
            if (this.customToolBars) {
                config.toolbars = [this.customToolBars];
            }
            // console.log(config)
            this.ue = UE.getEditor(this.ueEditorId, config);
            this.$emit("ue-export", this.ue);
            this.ue.ready(() => {
                this.hasReady = true;
                this.addEditorEventlistener();
                if (hasSupportObserver) {
                    this.resizeObserver = new window['ResizeObserver'](() => {
                        this.handleImageSizeChange();
                    });
                }
                if (this.ueContent) {
                    this.ue.setContent(this.ueContent);
                }
                if (this.ueReadyCallBack && this.ueReadyCallBack instanceof Function) {
                    this.ueReadyCallBack(this.ue);
                }
                if (!this.allowCustomEdit) {
                    this.ue.setDisabled();
                }
                this.$emit("ue-ready", this.ue);
            });
        });
    }
    beforeDestroy() {
        let instantKey = '';
        Object.entries(UE.instants).some(([key, instant]) => {
            if (instant.key === this.ueEditorId) {
                instantKey = key;
                return true;
            }
        });
        this.$delete(window.UE.instants, instantKey);
        this.ue.destroy();
    }
    handleImageSizeChange() {
        this.ue && this.ue.fireEvent("contentChange");
    }
    /**
    * previewShow 是否显示预览界面
    * bool state 代表显示的状态，true为显示，false为不显示
    * return
    */
    previewShow(state) {
        this.$emit("preview-state", state);
        if (state) {
            this.ueHtml = this.ue.getContent();
            this.previewStatus = true;
            this.previewCon = true;
        }
        else {
            this.previewCon = false;
            setTimeout(() => {
                this.previewStatus = false;
            }, 500);
        }
    }
    /**
     * showExample 是否显示范例
     * bool state 代表显示的状态，true为显示，false为不显示
     * return
     */
    showExample(state) {
        this.example = state;
    }
    // 获取富文本内的图片dom
    getEditorImages() {
        return [...this.ue.document.documentElement.querySelectorAll("img")];
    }
    // 富文本内的图片发生变更时执行
    handleBindImagesChange(oldImagesNodeList, currentImagesNodeList) {
        if (hasSupportObserver) {
            // 解绑旧节点的监听
            oldImagesNodeList.forEach(img => {
                this.resizeObserver.unobserve(img);
            });
            // 绑定新节点的监听
            currentImagesNodeList.forEach(img => {
                this.resizeObserver.observe(img);
            });
        }
        else {
            // 无需解除之前的劫持，会执行最新的setter
            currentImagesNodeList.forEach(img => {
                let width = img.width;
                Object.defineProperty(img, "width", {
                    configurable: true,
                    get() {
                        // 图片可能还未被设置width属性，会出现width和img.clientWidth不一致的情况
                        return Math.max(width, img.clientWidth);
                    },
                    set(val) {
                        // 拖拽的太小就还原不回去了，设置下缩小的最小取值
                        this.handleImageSizeChange();
                        width = Math.max(val, 12);
                    }
                });
            });
        }
        return currentImagesNodeList;
    }
    /**
     * addEditorlistenEve 添加富文本实例监听的事件
     * return 无
     */
    addEditorEventlistener() {
        const _ue = this.ue;
        let oldImagesNodeList = [];
        //监听文本变化---关闭监听文本
        _ue.addListener("contentChange", () => {
            const currentImagesNodeList = this.getEditorImages();
            const content = this.ue.getContent();
            const text = this.ue.getPlainTxt();
            // 插入了图片后重新监听事件
            if (currentImagesNodeList.length !== oldImagesNodeList.length) {
                oldImagesNodeList = this.handleBindImagesChange(oldImagesNodeList, currentImagesNodeList);
            }
            this.$emit("ue-content-change", content, "", text, this.indexUe);
        });
        //监听百度编辑器引入外部图片后的加载状态
        _ue.addListener("catchRemoteImageAjax", () => {
            this.catchRemoteState = true; //处于远程图片抓取状态，不能提交
            this.$emit("ue-load-img", this.catchRemoteState);
        });
        //监听百度编辑器引入外部图片后的成功状态
        _ue.addListener("catchremotesuccess", () => {
            if (this.catchRemoteState) {
                //处于远程图片抓取成功状态可提交
                this.catchRemoteState = false;
                this.$emit("ue-load-img", this.catchRemoteState);
            }
        });
        //监听百度编辑器引入外部图片后的失败状态
        _ue.addListener("catchremoteerror", () => {
            if (this.catchRemoteState) {
                //处于远程图片抓取成功状态可提交
                this.catchRemoteState = false;
                this.$emit("ue-load-img", this.catchRemoteState);
            }
        });
        // 监听点击图片上传按钮
        _ue.addListener("addimgv3", (_, files, cb) => {
            const file = files[0];
            service.postByForm('/courseAdmin/file/uploadFile', {
                uploadFile: file,
                businessType: 'rich',
                fileType: 'richPic'
            }).then(res => {
                cb({
                    url: res.data.data || '',
                    title: file.name,
                    original: file.name
                });
            });
            // this.triggerImgUpload()
        });
        // 监听点击音频上传按钮
        // _ue.addListener("addaudiov2", () => {
        //   this.triggerAudioUpload()
        // })
        // 监听点击视频上传按钮
        // _ue.addListener("addvideov2", () => {
        //   this.triggerVideoUpload()
        // })
        // 监听内容区的剪切事件
        _ue.body.addEventListener("cut", event => {
            // 在剪切完成之后触发contentChange
            setTimeout(() => {
                _ue.fireEvent("contentChange");
            }, 0);
        });
    }
    // 设置内容
    setContent(content) {
        if (this.hasReady) {
            this.ue.setContent(content);
        }
    }
    // 获取最新内容
    getContent() {
        return {
            id: this.ueId,
            content: this.ue.getContent(),
            plainText: this.ue.getPlainTxt()
        };
    }
};
tslib_1.__decorate([
    Prop({ type: Number })
], UEditor.prototype, "indexUe", void 0);
tslib_1.__decorate([
    Prop({ type: Object, default: null })
], UEditor.prototype, "ueConfig", void 0);
tslib_1.__decorate([
    Prop({ type: [Number, String], default: 0 })
], UEditor.prototype, "ueId", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], UEditor.prototype, "ueContent", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], UEditor.prototype, "ueSelfPreviwe", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: '<span style="color:#B2B2B2">请输入内容</span>' })
], UEditor.prototype, "ueInitContent", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: true })
], UEditor.prototype, "allowCustomEdit", void 0);
tslib_1.__decorate([
    Prop({ type: Array })
], UEditor.prototype, "customToolBars", void 0);
tslib_1.__decorate([
    Prop({ type: Function })
], UEditor.prototype, "ueReadyCallBack", void 0);
tslib_1.__decorate([
    Debounce(300)
], UEditor.prototype, "handleImageSizeChange", null);
UEditor = tslib_1.__decorate([
    Component({
        name: 'UEditor',
    })
], UEditor);
export default UEditor;
